import React from 'react';
import PropTypes from 'prop-types';

import * as htmlParser from 'react-html-parser';

import Video from '_core/components/Video';

export default class extends React.PureComponent {
  static propTypes = {
    style: PropTypes.object,
    children: PropTypes.string
  };

  static defaultProps = {};

  constructor(props) {
    super(props);
  }

  render() {
    const { style, children } = this.props;

    const transform = (node, index) => {
      if (node.type === 'comment' || node.type === 'style') return null;

      if (!node.parent && node.type === 'tag') {
        if (!node.attribs) node.attribs = {};

        node.attribs['class'] = node.attribs['class']
          ? node.attribs['class'] + ' ck-content'
          : 'ck-content';
      }

      if (
        node.type === 'tag' &&
        node.name === 'oembed' &&
        node.parent?.type === 'tag' &&
        node.parent.name === 'figure' &&
        node.attribs?.url
      )
        return (
          <Video
            id={node.attribs.id}
            className={node.attribs['class']}
            src={node.attribs.url}
          />
        );

      const result = htmlParser.convertNodeToElement(node, index, transform);

      let propsReplace = null;

      if (node.type === 'tag') {
        if (style && style[node.name])
          propsReplace = prop(propsReplace, 'style', style[node.name]);
      }

      if (propsReplace)
        return React.cloneElement(result, { ...result.props, ...propsReplace });

      return result;
    };

    return htmlParser.default(children || '', { transform });
  }
}

const prop = (props, name, value) => {
  if (!props) props = {};

  props[name] = value;

  return props;
};
